import * as yup from "yup";

export const createWebinarSchema = yup.object().shape({
  webinarName: yup.string().required("Webinar name is required"),
  webinarStartTime: yup.string().required("Start time is required"),
  webinarEndTime: yup.string().required("End time is required"),
  speakerInfo: yup.string().required("Speaker info is required"),
  webinarThumbnail: yup.string().required("Thumbnal is required"),
  webinarDate: yup.date().required("Webinar date is required"),
  description: yup.string().required("Description is required"),
});
